import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as UserGameProfileActions from './user-game-profile.actions';
import * as UserGameProfileSelectors from './user-game-profile.selectors';
import { UserGameProfile } from '@fantaz/shared/data-access/models';

@Injectable()
export class UserGameProfileFacade {
  isSaving$ = this.store.select(
    UserGameProfileSelectors.getUserGameProfileSaving,
  );

  constructor(private readonly store: Store) {}

  /**
   * Function to save user game profile
   *
   * @param userGameProfile UserGameProfile
   */
  saveUserGameProfile(userGameProfile: UserGameProfile) {
    this.store.dispatch(
      UserGameProfileActions.saveUserGameProfile({ userGameProfile }),
    );
  }
}
